import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import config from '../config/config';
import '../components/PatentForm.css';

function Preview() {
    const BASE_URL = config.mode === "dev" ? config.URL : config.LiveURL;

    const location = useLocation();
    const { data } = location.state || {};
    const { overview } = location.state || {};

    const navigate = useNavigate();

    const keys = Object.keys(data || {});
    const section = keys[0];
    const jd = data[section];
    const [editableContent, setEditableContent] = useState(data?.[section] || '');



    const [preamble, setPreamble] = useState('');
    const [transitional, setTransitional] = useState('');
    const [body, setBody] = useState('');
    const [dependentClaims, setDependentClaims] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!overview || !section) {
            navigate("/patentform", { replace: true });
        }
    }, [overview, section, navigate]);

    useEffect(() => {
        if (!data?.[section]) {
            navigate("/patentform", { replace: true });
            return;
        }

        const generateSections = async () => {
            try {
                const claims = data?.[section];

                // 1️⃣ Get transitional, body, dependentClaims from your API
                const response = await axios.post(`${BASE_URL}api/pre`, {
                    claims,
                    overview
                });

                const { transitional, body, dependentClaims } = response.data;

                // 2️⃣ Extract only the preamble from claim 1 using the transitional word
                const claimLines = claims.split(/\n+/);
                const claim1 = claimLines.find(line => line.trim().startsWith("1.")) || "";

                let preamble = "";

                if (transitional) {
                    const regex = new RegExp(`\\b${transitional}\\b`, "i");
                    const splitParts = claim1.split(regex);
                    preamble = splitParts[0].replace(/^1\.\s*/, '').trim();
                } else {
                    preamble = claim1.replace(/^1\.\s*/, '').trim();
                }

                // 3️⃣ Set the states
                setPreamble(preamble);
                setTransitional(transitional);
                setBody(body);
                setDependentClaims(dependentClaims);
            } catch (err) {
                alert("Error generating sections.");
                console.error(err);
            }
        };


        generateSections();
    }, [data?.[section], overview, navigate, BASE_URL]);


    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        const claims = data?.[section];
        
        try {
            const response = await axios.post(`${BASE_URL}` + 'api/generate-patent', {
                overview,
                preamble,
                transitional,
                body,
                
                claims
            });
            const patentData = response.data.data;
            navigate('/fullpreview', { state: { data: patentData } });

        } catch (error) {
            console.error('Error generating patent:', error);
        } finally {
            setLoading(false);
        }
    };



    const handleChange = (e) => {
        setEditableContent(e.target.value);
    };

    const handleSave = async () => {
        try {
            // You can POST the edited content if needed
            const response = await axios.post(`${BASE_URL}api/saveEditedPatentSection`, {
                overview,
                section,
                updatedContent: editableContent
            });

            alert("Section saved successfully!");
        } catch (error) {
            alert("❌ Error saving section.");
        }
    };

    return (
        <div style={{ width: "100%" }}>
            <div style={{ display: "flex", justifyContent: "end", margin: "10px" }}>
                <button onClick={() => navigate('/patentform')} className="button secondary-button">
                    Back
                </button>
            </div>
            <div style={{ display: 'flex', width: '100%', justifyContent: "space-between" }}>
                {/* Left Column - Editable Claim */}
                <div style={{ width: "50%" }}>
                    <h2>Patent Preview - Editable Claim</h2>
                    <textarea
                        className="editable-textarea"
                        value={editableContent}
                        onChange={(e) => setEditableContent(e.target.value)}
                        rows={20}
                        style={{ width: '100%', padding: '10px', fontSize: '16px' }}
                    />

                    <div style={{ marginTop: "20px" }} >

                        <button type="submit" disabled={loading} className="button" onClick={handleSubmit}>
                            {loading ? 'Generating...' : 'Generate Patent'}
                        </button>


                    </div>
                </div>

                {/* Right Column - Generated Sections */}
                <div style={{ width: "40%" }}>
                    <div style={{ marginBottom: '20px' }}>
                        <h4>Preamble</h4>
                        <textarea
                            value={preamble}
                            onChange={(e) => setPreamble(e.target.value)}
                            rows={5}
                            style={{ width: '100%', padding: '10px', fontSize: '14px' }}
                        />
                    </div>

                    <div style={{ marginBottom: '20px' }}>
                        <h4>Transitional Phrase</h4>
                        <textarea
                            value={transitional}
                            onChange={(e) => setTransitional(e.target.value)}
                            rows={3}
                            style={{ width: '100%', padding: '10px', fontSize: '14px' }}
                        />
                    </div>

                    <div style={{ marginBottom: '20px' }}>
                        <h4>Body</h4>
                        <textarea
                            value={body}
                            onChange={(e) => setBody(e.target.value)}
                            rows={8}
                            style={{ width: '100%', padding: '10px', fontSize: '14px' }}
                        />
                    </div>

                    <div style={{ marginBottom: '20px' }}>
                        <h4>Dependent Claims</h4>
                        <textarea
                            value={dependentClaims}
                            onChange={(e) => setDependentClaims(e.target.value)}
                            rows={5}
                            style={{ width: '100%', padding: '10px', fontSize: '14px' }}
                        />
                    </div>
                </div>
            </div>




        </div>
    );
}

export default Preview;
